import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const ActionsRow = ({ children }) => {
  return (
    <Box width="100%" maxWidth="400px" p={2} margin="0 auto">
      <FDStack spacing={2} direction="row" alignItems="center" justifyContent="flex-start">
        {children}
      </FDStack>
    </Box>
  );
};
ActionsRow.propTypes = {
  children: PropTypes.node.isRequired,
};
export default ActionsRow;
